import { useAuth } from '../auth';
import { useCheckChatAccessQuery, useUserSubscriptionQuery } from './use-gateway-queries';

/**
 * Effective purchased seat limit for the current org, or `undefined` if uncapped.
 *
 * - Manual (invoice-billed) orgs: the `manual_seat_count` cap, surfaced on
 *   checkChatAccess as `subscription.seatCount` when `billingType === 'manual'`.
 * - Stripe orgs: the subscription `quantity` (purchased licenses).
 */
export function useSeatLimit(): number | undefined {
  const { user } = useAuth();
  const { data: chatAccessData } = useCheckChatAccessQuery(!!user?.organizationId);
  const { data: subData } = useUserSubscriptionQuery(user?.id);

  const chatSub = chatAccessData?.body?.subscription;
  if (
    chatSub?.billingType === 'manual' &&
    typeof chatSub.seatCount === 'number' &&
    chatSub.seatCount > 0
  ) {
    return chatSub.seatCount;
  }

  const stripeSub = subData?.status === 200 ? subData.body.subscription : undefined;
  return typeof stripeSub?.quantity === 'number' && stripeSub.quantity > 0
    ? stripeSub.quantity
    : undefined;
}
